module.exports = __webpack_public_path__ + "img/christmas-lights-2021.b2a99cdd.jpg";